import React from 'react'
import { CMSOpportunityDetailsClientBaseType } from '../../../lib/types'

const CMSClientBase = ({ clientBase }: { clientBase?: CMSOpportunityDetailsClientBaseType }) => {
  return (
    <section data-testid='cms-client-base-content'>
      <section
        className='opportunity-cms-section-gallery flex flex-wrap flex-justify-center'
        data-testid='cms-client-base-images'
      >
        {clientBase?.clients?.map((client, idx: number) => (
          <section
            className='flex flex-justify-center flex-align-center flex-item-4col height-min-150px'
            key={idx}
          >
            <img src={client} alt={`Client ${idx + 1}`} />
          </section>
        ))}
      </section>
    </section>
  )
}

export { CMSClientBase }
